import React from "react";
import Banner from "../components/support/Banner";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
} from "@chakra-ui/react";
import CommonContainer from "../components/shared/CommonContainer";
import BuyersPanel from "../components/support/BuyersPanel";

export default function SupportPage() {
  return (
    <>
      <Banner />
      <CommonContainer>
        <Stack my={10}>
          <Tabs variant="unstyled" borderRadius={10} overflow="hidden">
            <TabList justifyContent={"center"} border={0}>
              <Tab
                _selected={{ color: "white", bg: "brand.500" }}
                bg="#f1f1f1"
                w="320px"
                border="1px solid gray"
                // borderLeft={0}
                // borderTop={0}
                borderRadius={"5px 0px 0px 5px"}
                fontWeight={"semibold"}
                sx={{ py: 4 }}
              >
                Buyers
              </Tab>
              <Tab
                _selected={{ color: "white", bg: "brand.500" }}
                bg="#f1f1f1"
                w="320px"
                border="1px solid gray"
                borderLeft={0}
                // borderTop={0}
                fontWeight={"semibold"}
                sx={{ py: 4 }}
              >
                Sellers
              </Tab>
              <Tab
                _selected={{ color: "white", bg: "brand.500" }}
                bg="#f1f1f1"
                w="320px"
                border="1px solid gray"
                borderLeft={0}
                // borderTop={0}
                fontWeight={"semibold"}
                // borderRight={0}
                borderRadius={"0px 5px 5px 0px"}
                sx={{ py: 4 }}
              >
                Fiverr Business Clients
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel p={0}>
                <BuyersPanel />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Stack>
      </CommonContainer>
    </>
  );
}
